import React, { useEffect } from "react";
import { Box, Collapse, Group, rem } from "@mantine/core";
import {
  IconCalendarStats,
  IconChevronLeft,
  IconChevronRight,
} from "@tabler/icons-react";
import swal from "sweetalert";

import { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { isSubscriptionExpired } from "../../utils";
import useStyles from "./style";
import ToolTip from "../ToolTip/ToolTip";
import { useSelector } from "react-redux";

export function LinksGroup({
  to,
  label,
  tooltipLabel,
  initiallyOpened,
  links,
  imgsrc,
  onClick,
  setIsOpen,
  isSidebarOpen,
  matchPaths = [],
}) {
  const location = useLocation();
  const { profile } = useSelector((state) => {
    return state?.profile;
  });

  const { classes, theme, cx } = useStyles();
  const hasLinks = Array.isArray(links);
  const navigate = useNavigate();
  const [opened, setOpened] = useState(initiallyOpened || false);
  const ChevronIcon = theme.dir === "ltr" ? IconChevronRight : IconChevronLeft;
  const billing = useSelector((state) => state.featureFlags.billing);
  const { signature } = useSelector((state) => state?.signature);

  const isAdmin = profile?.user?.role === "admin" && Boolean(profile?.user?.type);

  // if ((label === "Billing" || to === "billing") && !billing) {
  //   return null;
  // }
  if (!isAdmin && (label === "Billing" || to === "billing") && !billing) {
    return null;
  }

  const requiresSignature = ["note", "tasks", "medication", "patient"].includes(
    to?.toLowerCase()
  );

  const _isActive =
    location.pathname === to ||
    location.pathname?.split("/")?.slice(1)?.join()?.includes(to);

  const hasFacilityWith2FA = Array.isArray(profile?.user?.facilityId)
    ? profile?.user?.facilityId?.some(
        (facility) => facility?.twoFactorAuth === true
      )
    : false;

  const items = (hasLinks ? links : []).map((link, i) => (
    <NavLink
      className={({ isActive, isPending }) =>
        isActive ? cx(classes.link, classes.linkActive) : classes.link
      }
      attr={link.attr && link.attr}
      to={link.to}
      key={i}
      onClick={(event) => {
        event.preventDefault();
        navigate(link.to);
      }}
      end
    >
      {link.label}
    </NavLink>
  ));

  return (
    <>
      <NavLink
        className={({ isActive }) =>
          (isActive || _isActive) && isSidebarOpen
            ? cx(classes.link, classes.linkActive)
            : (isActive || _isActive) && !isSidebarOpen
            ? cx(
                classes.linkClose,
                classes.linkActiveClose,
                classes.drawerClosedLink
              )
            : classes.link
        }
        to={to}
        key={label}
        onClick={(e) => {
          e.preventDefault();
          if (!isSubscriptionExpired()) {
            if (requiresSignature && (signature === null || !signature)) {
              swal({
                title: "Signature Required",
                text: "Please add a signature from setting page to continue",
                dangerMode: true,
                icon: "warning",
                buttons: {
                  cancel: {
                    text: "Cancel",
                    visible: true,
                    className: classes.cancelBtn,
                  },
                  confirm: {
                    text: "Setup Signature",
                    value: true,
                    className: classes.setupBtn,
                  },
                },
              }).then((value) => {
                if (value) {
                  navigate("/home/settings", {
                    state: { selectedTab: "my-signature" },
                  });
                }
              });
            } else if (
              hasFacilityWith2FA &&
              requiresSignature &&
              profile?.user?.type === "staff" &&
              profile?.user?.twoFactorVerified === false
            ) {
              swal({
                title: "2FA Verification Required",
                text: "Please complete 2FA verification setup to continue",
                dangerMode: true,
                icon: "warning",
                buttons: {
                  cancel: {
                    text: "Cancel",
                    visible: true,
                    className: classes.cancelBtn,
                  },
                  confirm: {
                    text: "Setup 2FA",
                    value: true,
                    className: classes.setupBtn,
                  },
                },
              }).then((value) => {
                if (value) {
                  navigate("/home/settings", {
                    state: { selectedTab: "security", reset2fa: true },
                  });
                }
              });
            } else {
              navigate(to);
              setOpened((o) => !o);
              setIsOpen(false);
              if (hasLinks) onClick?.();
            }
          }
        }}
        style={{
          background:
            isSubscriptionExpired() ||
            (["note", "tasks", "medication", "patient"].includes(
              to?.toLowerCase()
            ) &&
              (!signature || signature === null))
              ? "#ebebeb"
              : requiresSignature &&
                profile?.user?.type === "staff" &&
                hasFacilityWith2FA &&
                profile?.user?.twoFactorVerified === false
              ? "#ebebeb"
              : "",
        }}
        end
      >
        <Group spacing={"sm"} sx={{ width: "100%" }}>
          {isSidebarOpen ? (
            <>{imgsrc}</>
          ) : (
            <ToolTip
              position={"right-end"}
              toolTipLabel={tooltipLabel}
              imgsrc={imgsrc}
            />
          )}

          <div className={classes.row}>
            <span className={classes.label}>{label}</span>
            {hasLinks && (
              <ChevronIcon
                className={classes.chevron}
                size="1.5rem"
                stroke={1.5}
                style={{
                  transform: opened
                    ? `rotate(${theme.dir === "rtl" ? 90 : -90}deg)`
                    : "none",
                }}
              />
            )}
          </div>
        </Group>
      </NavLink>
      {hasLinks ? <Collapse in={opened}>{items}</Collapse> : null}
    </>
  );
}

const mockdata = {
  label: "Releases",
  icon: IconCalendarStats,
  links: [
    { label: "Upcoming releases", link: "/" },
    { label: "Previous releases", link: "/" },
    { label: "Releases schedule", link: "/" },
  ],
};

export function NavbarLinksGroup() {
  return (
    <Box
      sx={(theme) => ({
        minHeight: rem(220),
        padding: theme.spacing.md,
        backgroundColor:
          theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
      })}
    >
      <LinksGroup {...mockdata} />
    </Box>
  );
}
